import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    flyingCartItemRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    flyingCartItemLabel: {
        color: theme.palette.secondary.main,
    },
    flyingCartItemPrice: {
        color: theme.palette.secondary.main,
    },
    flyingCartTotalRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    flyingCartTotalLabel: {
        color: theme.palette.secondary.main,
    },
    flyingCartTotalPrice: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightMedium,
    },
    priceSkeleton: {
        borderRadius: "14px",
        height: 32,
        marginBlock: "-7px",
        width: 60,
    },
}));
